const API_BASE_URL = '/api';
const AUTH_KEY = "auth_token";

let onAuthFailure = null;

export function setAuthFailureHandler(fn) {
    onAuthFailure = fn;
}

async function request(method, path, { params, body, raw } = {}) {
    let url = `${API_BASE_URL}${path}`;
    if (params) {
        const qs = new URLSearchParams(params).toString();
        if (qs) url += `?${qs}`;
    }

    const headers = {};
    if (!raw) headers['Content-Type'] = 'application/json';
    const token = localStorage.getItem(AUTH_KEY);
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const res = await fetch(url, {
        method,
        headers,
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });

    if (res.status === 403 && onAuthFailure) {
        onAuthFailure();
    }

    if (!res.ok) {
        const err = await res.json().catch(() => ({ message: res.statusText }));
        throw err;
    }

    if (raw) return res;
    if (res.status === 204) return null;
    return res.json();
}

async function upload(path, file) {
    const url = `${API_BASE_URL}${path}`;
    const headers = {};
    const token = localStorage.getItem(AUTH_KEY);
    if (token) headers['Authorization'] = `Bearer ${token}`;
    headers['Content-Type'] = file.type;

    const res = await fetch(url, { method: 'POST', headers, body: file });

    if (res.status === 403 && onAuthFailure) onAuthFailure();
    if (!res.ok) {
        const err = await res.json().catch(() => ({ message: res.statusText }));
        throw err;
    }
    return res.json();
}

const api = {
    get:    (path, opts) => request('GET', path, opts),
    post:   (path, body) => request('POST', path, { body }),
    put:    (path, body) => request('PUT', path, { body }),
    patch:  (path, body) => request('PATCH', path, { body }),
    delete: (path) => request('DELETE', path),
    upload,
};

export default api;
